import React from 'react';
import './footer.css';
//import NavOptions from '../navbar/navOptions';
import Contact from '../contact/contact';
import { Link } from 'react-router-dom';
import { HeartStraight } from "@phosphor-icons/react";

function Footer() {

    return (
        <>
            <footer className="footerContainer" id="contact">

                <div className="columnOne">
                    <Link to="./message" style={{ textDecoration: "none", color: "antiqueWhite !important", ariaLabel:"link to send message" }}>
                        <div className="button" style={{color: "antiquewhite"}}>CONTACT</div>
                    </Link>
                </div>
                <div className="columnOne">
                    <Link to="./mailingList" style={{ textDecoration: "none", color: "antique-white", ariaLabel:"link to join mailing list" }}>
                        <div className="button">MAILING LIST</div>
                    </Link>
                </div>
                <div className="columnOneContact">
                    <Contact className="columnOneContact" />
                </div>
                <p style={{color: "antiquewhite"}}> © 2024 Gary O'Donnell. <br></br>All rights reserved.<br></br>
                    Site made with <span><HeartStraight size={15} weight="bold" color="red" /> </span>by <span>
                        <br></br> <br></br>
                    <a href="https://www.thesongbird.co.uk"
                        style={{
                            textDecoration: "none",
                            color: "antiquewhite",
                            border: '3px solid antiquewhite',
                            borderRadius: "25px",
                            padding: '5px',
                            marginLeft: '2px',
                        }}
                        target="_blank"
                        aria-label="External link to the Songbird's website"
                        rel="noopener noreferrer"
                    > The Songbird
                    </a></span>
                </p>

            </footer>
        </>
    )
}

export default Footer;